import { render, staticRenderFns } from "./test-canvas.vue?vue&type=template&id=5baa4165&scoped=true&"
import script from "./test-canvas.vue?vue&type=script&lang=js&"
export * from "./test-canvas.vue?vue&type=script&lang=js&"
import style0 from "./test-canvas.vue?vue&type=style&index=0&id=5baa4165&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baa4165",
  null
  
)

export default component.exports